import React, { useContext } from "react";
import authContext from "../Context/AuthenticationContext";
const useAuth = ()=>{
    const context = useContext(authContext)
    if (!context) throw new Error('context must be use inside provider');

    return context;
}

export default useAuth